import React from "react";

const CollegeAdminHelpInstructions = () => {
  return (
    <div className="card-wrap" id="studentresource">
      <div className="title">
        <h2>Help</h2>
      </div>
      <div className="row help-wrap">
        <div className="col-lg-3 col-md-3">
          <div className="sidebar" id="sidebar">
            <h2>Table of Contents</h2>
            <a href="#introduction">Introduction</a>
            <a href="#login">Login</a>
            <a href="#visibility-priority">1. Visibility & Priority Settings</a>
            <a href="#feedback">2. Feedback</a>
            <a href="#settings">3. Settings</a>
            <a href="#navbar">4. Navigation Bar</a>
          </div>
        </div>
        <div className="col-lg-9 col-md-3">
          <div className="content">
            <div id="introduction" className="section">
              <h2>Introduction</h2>
              <p>
                This user manual serves as a comprehensive guide to help you
                navigate the Budu Portal with ease. It covers key features,
                step-by-step instructions, and tips to make the most of the
                portal’s capabilities.
              </p>
            </div>

            <div id="login" className="section">
              <h2>Login</h2>
              <p>
                The login page allows College Admin user to securely sign in.
                Follow these steps:
              </p>
              <ol>
                <li>
                  Click the URL:{" "}
                  <a
                    href="https://demo.ui.buduportal.com/login"
                    target="_blank"
                  >
                    https://demo.ui.buduportal.com/login
                  </a>
                </li>
                <li>Enter username and password in the fields provided.</li>
                <li>Click the 'Login' button to access the main dashboard.</li>
              </ol>
              <img src="assets/images/help/login.png" alt="Login" />
            </div>

            <div id="visibility-priority" className="section">
              <h2>1. Visibility & Priority Settings</h2>
              <p>
                Users have the ability to set the visibility and priority of
                configured dashboard items based on different personas: Staff,
                Student, and Faculty.
              </p>
              <h3>1.1 Student</h3>
              <ul>
                <li>Navigate to “ Student”</li>
                <li>
                  Change Visibility: Uncheck the radio button to hide any item.
                </li>
                <li>
                  Change Order: Drag and drop items to rearrange the display
                  order
                </li>
                <li>Filter – Page-Block</li>
              </ul>
              <h3>1.2 Faculty</h3>
              <ul>
                <li>Navigate to “ Faculty”</li>
                <li>
                  Change Visibility: Uncheck the radio button to hide any item.
                </li>
                <li>
                  Change Order: Drag and drop items to rearrange the display
                  order
                </li>
                <li>Filter – Page-Block</li>
              </ul>

              <table className="feature-table">
                <tr>
                  <th>Feature</th>
                  <th>Super Admin</th>
                  <th>College Admin</th>
                  <th>Department Admin</th>
                  <th>Staff</th>
                  <th>Student/Freshman</th>
                  <th>Faculty</th>
                </tr>
                <tr>
                  <td>Staff Visibility and Priority settings</td>
                  <td>&#10004;</td>
                  <td>&#10008;</td>
                  <td>&#10004;</td>
                  <td>&#10004;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                </tr>
                <tr>
                  <td>Faculty Visibility and Priority settings</td>
                  <td>&#10004;</td>
                  <td>&#10004;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10004;</td>
                </tr>
                <tr>
                  <td>Student visibility and Priority Settings</td>
                  <td>&#10004;</td>
                  <td>&#10004;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10004;</td>
                  <td>&#10008;</td>
                </tr>
              </table>
            </div>

            <div id="feedback" className="section">
              <h2>2. Feedback</h2>
              <p>
                The Feedback module allows users to send feedback messages and
                rate their experience with the system. It includes options to
                submit comments, suggestions, and star ratings.
              </p>
              <h3>2.1 Sending Feedback</h3>
              <ul>
                <li>
                  Click on the Feedback Menu and it will be redirected to the
                  Feedback Page
                </li>
                <img src="assets/images/help/collegeAdmin_feedback.png" alt="Feedback" />
                <li>Subject: Enter Subject</li>
                <li>
                  Message: Type your message or comments in the Message field.
                </li>
                <li>Send: Click the Send button to submit your feedback.</li>
                <li>
                  Cancel: Click the Cancel button to discard your feedback and
                  return to the previous page.
                </li>
              </ul>
              <h3>2.2 Rate Us</h3>
              <ul>
                <li>
                  Rate Us Button : Click on rate us button , a rating popup will
                  appear.
                </li>
                <img src="assets/images/help/rating.png" alt="Rate Us" />
                <li>Select star rating to reflect your experience.</li>
                <li>
                  Provide any additional comments or suggestions in the input
                  field.
                </li>
                <li>
                  Submit : Click the Submit button to record your rating and
                  feedback.
                </li>
                <li>
                  Cancel: Click the Cancel button to discard your feedback
                </li>
              </ul>

              <table className="feature-table">
                <tr>
                  <th>Feature</th>
                  <th>Super Admin</th>
                  <th>College Admin</th>
                  <th>Department Admin</th>
                  <th>Staff</th>
                  <th>Student</th>
                  <th>Faculty</th>
                </tr>
                <tr>
                  <td>Feedback</td>
                  <td>&#10004;</td>
                  <td>&#10004;</td>
                  <td>&#10004;</td>
                  <td>&#10004;</td>
                  <td>&#10004;</td>
                  <td>&#10004;</td>
                </tr>
                <tr>
                  <td>Rate Us</td>
                  <td>&#10004;</td>
                  <td>&#10004;</td>
                  <td>&#10004;</td>
                  <td>&#10004;</td>
                  <td>&#10004;</td>
                  <td>&#10004;</td>
                </tr>
              </table>
            </div>

            <div id="settings" className="section">
              <h2>3. Settings</h2>
              <h3>3.1 Edit Profile</h3>
              <p>
                The Edit Profile option allows users to update their display
                name and profile picture.
              </p>
              <ul>
                <li>Navigate to the Settings Page.</li>
                <li>
                  Edit Profile Button : By clicking a popup will appear for
                  editing profile.
                </li>
                <img
                  src="assets/images/help/editProfile.png"
                  alt="Edit Profile"
                />
                <li>
                  Edit Icon: Click on the current profile image to upload a new
                  one.
                </li>
                <li>
                  Username : Edit the Username field to update your display name
                  on the portal.
                </li>
                <li>Save Changes: Click to Saves updated profile details.</li>
                <li>Close : Closes the popup without saving any changes.</li>
              </ul>
            </div>

            <div id="navbar" className="section">
              <h2>4. Navigation Bar</h2>
              <ul>
                <li>
                  Email: Clicking on the Email Icon will redirect to the Outlook
                  Mail Inbox.
                </li>
                <li>
                  Profile Icon: A list of university managements will be
                  displayed if multiple university managements are assigned to
                  the user. The user can switch between university managements
                  if needed. Once the Logout button is clicked, you will be
                  logged out and redirected to the login page.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CollegeAdminHelpInstructions;
